import { Routes } from '@angular/router';
import { ApplicationsEnum } from './platform/dtos/application.dto';
import { authChildGuard, authGuard } from './platform/guards/auth.guard';
import { NoSidebarLayoutComponent } from './platform/layout/no-sidebar-layout/no-sidebar-layout.component';
import { HomeComponent } from './platform/pages/home/home.component';
import { UserResolver } from './platform/resolvers/user.resolver';
import { DefaultLayoutComponent } from './platform/shared/default-layout/default-layout.component';
import { OnlyContentLayoutComponent } from './platform/shared/only-content-layout/only-content-layout.component';
import { StringEmpty } from './platform/utils/global-vars';

export const appRoutes: Routes = [
  {
    path: StringEmpty,
    redirectTo: '/home',
    pathMatch: 'full',
  },
  // No authenticated Routes
  {
    path: '',
    children: [
      {
        path: 'login',
        component: OnlyContentLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () => import('src/app/platform/pages/login/login.routing').then((m) => m.loginRoute),
          },
        ],
      },
      {
        path: 'meeting-email-confirmation',
        component: NoSidebarLayoutComponent,
        loadChildren: () =>
          import('./dsmb/pages/meeting-email-confirm/meeting-email-confirm.routing').then(
            (m) => m.meetingEmailConfirmRoute,
          ),
      },
      {
        path: 'privacy-policy',
        component: NoSidebarLayoutComponent,
        loadChildren: () =>
          import('src/app/platform/pages/privacy-policy/privacy-policy.routing').then((m) => m.privacyPolicyRoute),
      },
    ],
  },
  // Authenticated Routes
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    resolve: { data: UserResolver },
    children: [
      {
        path: '',
        data: {
          operation: 'view-profile-page',
          application: ApplicationsEnum.PLATFORM,
        },
        children: [
          {
            path: 'home',
            component: HomeComponent,
          },
          {
            path: 'user-document-view/organization/:organizationId/study/:studyId/:user/document/:documentId/version/:versionNo',
            component: OnlyContentLayoutComponent,
            loadChildren: () =>
              import('src/app/platform/pages/view-user-document/view-user-document.routing').then(
                (m) => m.viewUserDocumentRoute,
              ),
            data: {
              operation: 'view-panel-document-page',
              application: ApplicationsEnum.DSMB,
            },
          },
          {
            path: 'user-document-view/:user/document/:documentId/version/:versionNo',
            component: OnlyContentLayoutComponent,
            loadChildren: () =>
              import('src/app/platform/pages/view-user-document/view-user-document.routing').then(
                (m) => m.viewUserDocumentRoute,
              ),
            data: {
              operation: 'view-panel-document-page',
              application: ApplicationsEnum.DSMB,
            },
          },
          {
            path: '',
            loadChildren: () => import('./platform/platform.routing').then((m) => m.platformRoutes),
          },
        ],
      },
      // Profile page
      {
        path: 'profile',
        component: DefaultLayoutComponent,
        loadChildren: () => import('src/app/platform/pages/profile/profile.routing').then((m) => m.profileRoute),
        data: {
          operation: 'view-profile-page',
          application: ApplicationsEnum.PLATFORM,
          breadcrumbs: {
            label: 'platform.profile.title',
            url: '/profile',
          },
        },
      },
    ],
  },
  {
    path: 'error',
    component: NoSidebarLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/platform/pages/page-error/page-error.routing').then((m) => m.pageErrorRoute),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/error/page-not-found',
  },
];
